module.exports = __webpack_public_path__ + "media/miracle.9a995026.mp4";